import { useState } from "react";
import PaymentLayout from "./PaymentLinkLayouts";
import CountDownTimer from "../components/CountDownTimer";
import formatCurrency from "../../utils/numberFormatter";
import { useSelector } from "react-redux";
import darkenColor from "../utils/darkenColor"; // ✅ Import darkenColor terpisah
import { stripLinkquLabel } from "../utils/paymentMethodDisplay";
import useTranslation from "../hooks/useTranslation";

export default function PaymentInstructionLayout({
  amount,
  orderId,
  merchantName,
  expiredAt,
  selectedMethod,
  paymentCredential,
  howToPay,
  isShowCredensial = true,
  onCheckStatus, // Tambahkan prop untuk mengecek status transaksi
}) {

  const { t } = useTranslation();
  const {
    secondary_color,
    secondary_text_color,
    tertiary_text_color,
    card_title,
  } = useSelector((state) => state.style);
  const buttonTextColor = tertiary_text_color || secondary_text_color || "#FFFFFF";

  const [loading, setLoading] = useState(false);
  const displaySelectedMethod = stripLinkquLabel(selectedMethod);

  const onExpireCountDown = async () => {
    //cek lagi dan biarkan parent yang handle
    await onCheckStatus(orderId);
  };

  const handleCheckStatus = async () => {
    setLoading(true);
    try {
      await onCheckStatus(orderId);
    } catch (error) {
      console.error("Failed to check transaction status:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PaymentLayout title={card_title || merchantName}>
      {/* Order Details */}
      <div>
        <h2 className="text-4xl font-bold">{formatCurrency(amount).split(",")[0]}</h2>
        <p className="text-gray-600 mt-2">
          {t("paymentInstructionLayout.reffNo")} {orderId}
        </p>
        <div className=" text-gray-600">
          {t("paymentInstructionLayout.method")} {displaySelectedMethod}
        </div>
      </div>

      {/* Expired or Countdown Timer */}
      <div className="bg-gray-50 p-4 rounded-lg text-center">
          <p className="text-gray-600">
            {t("paymentInstructionLayout.payWithin")}{" "}
            <CountDownTimer expiredAt={expiredAt} onExpire={onExpireCountDown} />
          </p>
      </div>

      {/* Payment Credential & How to Pay (Hidden if expired) */}
      {isShowCredensial && (
        <>
          <div className="mt-4">{paymentCredential}</div>
          <div className="mt-6">{howToPay}</div>
        </>
      )}

      {/* Tombol Cek Status Transaksi */}
      <button
        className={`w-full py-4 px-6 rounded-md text-xl font-medium transition-colors bg-gray-900 hover:bg-gray-800 text-white`}
        style={{ 
          backgroundColor: secondary_color,
          color: buttonTextColor
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = darkenColor(secondary_color, 15);
          e.target.style.color = darkenColor(buttonTextColor, 15);
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = secondary_color;
          e.target.style.color = buttonTextColor;
        }}
        onClick={handleCheckStatus}
        disabled={loading}
      >
        {loading ? t("paymentInstructionLayout.checking") : t("paymentInstructionLayout.checkTransactionStatus")}
      </button>
    </PaymentLayout>
  );
}
